/*
 * localizable.js
 *
 * Speakers
 * Created by Mahdi Yousefpour on Fri Feb 03 2023 mys Company
 */

import LocalizedStrings from 'react-localization'

export const localization = new LocalizedStrings({
    en: {
        productname: 'Speakers',
        ok: 'Ok',
        cancel: 'Cancel',
        mobilenumber: 'Mobile Number',
        password: 'Password',
        adminpanel: 'Admmin Panel',
        username: 'نام کاربری ',
        submit: 'ارسال',
        loading: 'loading',
        appconfig: 'appconfig',
        baseinfo: 'base info',
        mainmenu: 'main menu',
        other: 'other',
        article: 'article',
        blog: 'blog',
        menu: 'menu',
        permission: 'permission',
        group: 'group',
        category: 'category',
        comment: 'comment',
        staticpages: 'staitc pages',
        contactus: 'contactus',
        aboutus: 'aboutus',
        advertisement: 'advertisement',
        favorite: 'favorite',
        newstypes: 'news types',
        newstype: 'news type',
        tag: 'tag',
        tags: 'tags',
        slider: 'slider',
        dashboard: 'dashboard',
        post: 'post',
        news: 'news',
        brand: 'برند',
        product: 'محصول',
        property: 'ویژگی',
        shopping: 'فروشگاه',
        user: 'کاربر',
        setting: 'تنظیمات',
        profile: 'پروفایل',
        specific: 'اختصاصی',
        location: 'محل',
        expert: 'متخصص',
        home: 'صفحه اصلی',
        faq: 'پرسش و پاسخ',
        newsletter: 'خبرنامه',
        task: 'وظیفه',
        ticket: 'بلیت',
        city: 'شهر',
        activationcode: 'کد فعالسازی',
        number: 'شماره',
        title: 'عنوان',
        date: 'تاریخ',
        actions: 'عمل ها',
        delete: 'حذف',
        edit: 'ویرایش',
        images: 'ویرایش',
        gallery: 'گالری',
        header: 'هدر',
        sidebar: 'منوی کناری',
        container: 'محتوایی',
        right: 'راست',
        left: 'چپ',
        wide: 'عریض',
        top: 'بالا',
        vertical: 'عمودی',

        MSG_username_isrequired: 'Username is required',
        MSG_password_isrequired: 'password is required',
        MSG_mobile_isrequired: 'mobile number is required',
        MSG_code_isrequired: 'code number is required',

        MSG_mincharacter: 'min character',
        MSG_maxcharacter: 'max character',

        error_500: 'Please try later!',
        error_500: 'Please try later!',

        caption_appconfig: 'مدیریت برنامه ها',
        caption_baseinfo: 'اطلاعات پایه',
        caption_mainmenu: 'منوی اصلی',
        caption_other: 'سایر',
        caption_article: 'مقاله',
        caption_blog: 'بلاگ',
        caption_menu: 'منو',
        caption_permission: 'دسترسی',
        caption_group: 'گروه',
        caption_category: 'دسته بندی',
        caption_comment: 'نظر',
        caption_news: 'خبرها',
        caption_post: 'پست',
        caption_dashboard: 'پیشخوان',
        caption_slider: 'اسلایدر',
        caption_tag: 'تگ',
        caption_newstype: 'نوع خبر',
        caption_newstypes: 'خبر و انواع',
        caption_favorite: 'علاقه مندی ها',
        caption_advertisement: 'تبلیغات',
        caption_aboutus: 'درباره ما',
        caption_contactus: 'تماس با ما',
        caption_staticpages: 'صفحه های ایستا',
        caption_brand: 'برند',
        caption_product: 'محصول',
        caption_property: 'ویژگی',
        caption_shopping: 'فروشگاه',
        caption_user: 'کاربر',
        caption_setting: 'تنظیمات',
        caption_profile: 'پروفایل',
        caption_specific: 'اختصاصی',
        caption_location: 'محل',
        caption_expert: 'متخصص',
        caption_home: 'صفحه اصلی',
        caption_faq: 'پرسش و پاسخ',
        caption_newsletter: 'خبرنامه',
        caption_task: 'وظیفه',
        caption_ticket: 'بلیت',
        caption_city: 'شهر',
        caption_activationcode: 'کد فعالسازی',
    },
    'fa-IR': {
        productname: 'سخنران',
        ok: 'تایید',
        update: 'بروزرسانی',
        cancel: 'لغو',
        mobilenumber: 'شماره موبایل',
        password: 'رمز عبور',
        passwordconfirm: 'تایید رمز عبور',
        adminpanel: 'پنل مدیریت',
        username: 'نام کاربری ',
        submit: 'ارسال',
        loading: 'در حال بارگذاری',
        appconfig: 'مدیریت برنامه ها',
        baseinfo: 'اطلاعات پایه',
        mainmenu: 'منوی اصلی',
        childmenu: 'زیرمنو',
        other: 'سایر',
        message: 'پیام',
        visit: 'دیدن',
        publicread: 'خواندن عمومی',
        article: 'مقاله',
        blog: 'بلاگ',
        menu: 'منو',
        permission: 'دسترسی',
        group: 'گروه',
        category: 'دسته بندی',
        comment: 'نظر',
        news: 'خبرها',
        post: 'پست',
        dashboard: 'پیشخوان',
        slider: 'اسلایدر',
        tag: 'تگ',
        tags: 'تگها',
        newstype: 'نوع خبر',
        newstypes: 'نوعهای خبر',
        favorite: 'علاقه مندی ها',
        advertisement: 'تبلیغات',
        aboutus: 'درباره ما',
        contactus: 'تماس با ما',
        staticpages: 'صفحه های ایستا',
        brand: 'برند',
        product: 'محصول',
        property: 'ویژگی',
        shopping: 'فروشگاه',
        user: 'کاربر',
        setting: 'تنظیمات',
        profile: 'پروفایل',
        specific: 'اختصاصی',
        location: 'محل',
        expert: 'متخصص',
        home: 'صفحه اصلی',
        faq: 'پرسش و پاسخ',
        newsletter: 'خبرنامه',
        task: 'وظیفه',
        ticket: 'بلیت',
        city: 'شهر',
        province: 'استان',
        activationcode: 'کد فعالسازی',
        number: 'شماره',
        title: 'عنوان',
        name: 'نام',
        date: 'تاریخ',
        actions: 'عمل ها',
        create: 'ایجاد',
        delete: 'حذف',
        read: 'خواندن',
        edit: 'ویرایش',
        images: 'عکس ها',
        gallery: 'گالری',
        video: 'تصویر',
        videos: 'تصویرها',
        music: 'موسیقی',
        musics: 'موسیقی ها',
        sound: 'صدا',
        sounds: 'صداها',
        chooseone: 'یگ کزینه را انتخاب کنید',
        type: 'نوع',
        level: 'سطح',
        parent: 'والد',
        description: 'توضیح',
        otpcode: 'کد امنیتی',
        primaryimage: 'تصویر اصلی',
        save: 'ذخیره',
        add: 'افزودن',
        yes: 'بله',
        no: 'خیر',
        forceupdate: 'بروزرسانی اجباری',
        direction: 'جهت',
        platform: 'بستر',
        menuversion: 'نسخه منو',
        appUrl: 'آدرس برنامه',
        rtl: 'راست به چپ',
        ltr: 'چپ به راست',
        ios: 'iOS',
        android: 'اندروید',
        webbusiness: 'سایت-کسب و کار',
        webadmin: 'سایت-پنل ادمین',
        webcustomer: 'سایت-مشتری',
        pwa: 'Pwa',
        splashipad: 'آدرس تصویر تبلت',
        splashiphone: 'آدرس تصویر موبایل',
        theme: 'قالب زمینه',
        version: 'نسخه',
        urldescription: 'لینک توضیحات',
        link: 'لینک',
        clientkey: 'کلید برنامه',
        meta: 'متا',
        urlPath: 'آدرس سئو',
        metaTitle: 'عنوان متا',
        metaDescription: 'توضیح متا',
        latitude: 'عرض جغرافیای',
        longitude: 'طول جغرافیایی',
        cityCount: 'تعداد شهر',
        header: 'هدر',
        container: 'محتوایی',
        right: 'راست',
        left: 'چپ',
        wide: 'عریض',
        top: 'بالا',
        priority: 'اولویت',
        author: 'نویسنده',
        authorlink: 'لینک نویسنده',
        important: 'مهم',
        rate: 'امتیاز',
        likes: 'علاقه مندی ها',
        like: 'علاقه مندی',
        firstname: 'نام',
        lastname: 'نام خانوادگی',
        nickname: 'نام مستعار',
        email: 'ایمیل',
        phone: 'تلفن',
        fax: 'فکس',
        postalcode: 'شماره پستی',
        address: 'آدرس',
        barcode: 'بارکد',
        suggestphone: 'تلفن پیشنهادی',
        criticismphone: 'تلففن های ضروری',
        businesstime: 'زمان کاری',
        onthemapdesc: 'توضیحات ما رو نقشه',
        subtitle: 'زیر عنوان',
        subtitledesc: 'توضیحات ثانویه',
        isused: 'استفاده شده',
        code: 'کد',
        visible: 'قابل نمایش',
        icon: 'آیکن',
        caption: 'عنوان نمایشی',
        section: 'بخش',
        birthdate: 'تاریخ تولد',
        gender: 'جنسیت',
        male: 'مذکر',
        female: 'مونث',
        accountinfo: 'اطلاعات حساب',
        playlist: 'لیست آلبوم ها',
        sourceLink: 'لینک مبدا',
        tel: 'تلفن',
        website: 'وب سایت',
        slogan: 'شعار',
        manager: 'مدیر',
        physical: 'فیزیکی',
        virtual: 'مجازی',
        download: 'دانلود',
        model: 'مدل',
        availableCount: 'تعداد موجود',
        weight: 'وزن',
        width: 'عرض',
        height: 'ارتفاع',
        length: 'طول',
        text: 'متنی',
        publisheddate: 'تاریخ انتشار',
        publish: 'انتشار',
        checkbox: 'چک باکس',
        select: 'انتخاب',
        selective: 'انتخابی',
        page: 'صفحه',
        celltype: 'نوع سطر',
        live: 'زنده',
        search: 'جستجو',
        expireDate: 'تاریخ انقضا',
        hizb: 'حزب',
        juz: 'جز',
        surah: 'سوره',
        verse: 'آیه',
        versesCount: 'تعداد آیه ها',
        dailytodo: 'اعمال مستحبی',
        dailytodoitem: 'موارد اعمال مستحبی',
        englishname: 'نام انگلیسی',
        mecca: 'مکه',
        madinah: 'مدینه',
        faInterpretation: 'تحلیل فارسی',
        faTranslate: 'ترجمه فارسی',
        prostration: 'سجده',
        linkType: 'نوع لینک',
        size: 'اندازه',
        internal: 'داخلی',
        external: 'خارجی',

        //******************* PER PROJECT ******************

        // : '',
        // : '',
        // : '',
        // : '',
        // : '',
        // : '',
        // : '',
        // : '',
        // : '',
        // : '',
        // : '',
        // : '',
        // : '',
        // : '',
        // : '',
        // : '',
        // : '',
        // : '',
        // : '',
        // : '',
        // : '',
        // : '',

        MSG_username_isrequired: 'نام کاربری الزامی است',
        MSG_password_isrequired: 'رمز عبور الزامی است',
        MSG_name_isrequired: 'نام الزامی است',
        MSG_title_isrequired: 'عنوان الزامی است',
        MSG_group_isrequired: 'گروه الزامی است',
        MSG_firstname_isrequired: 'نام الزامی است',
        MSG_lastname_isrequired: 'نام خانوادگی الزامی است',
        MSG_description_isrequired: 'توضیحات الزامی است',
        MSG_path_isrequired: 'آدرس الزامی است',
        MSG_mobile_isrequired: 'شماره موبایل الزامی است',
        MSG_address_isrequired: 'آدرس الزامی است',
        MSG_file_isnotchoose: 'قایلی انتخاب نشده است',
        MSG_code_isrequired: 'کد امنیتی الزامی است',
        MSG_type_isrequired: 'نوع الزامی است',
        MSG_itisshowontheperesentaion: 'این فیلد به کاربر نمایش داده میشود',
        MSG_mincharacter: 'تعداد حروف وارد شده کم است',
        MSG_maxcharacter: 'تعداد حروف وارد شده زیاد است',
        MSG_doyouwanttodeleterecord: 'آیا از حذف این داده مطمین هستین؟',

        error_500: 'خطایی رخ داده است لطفا لحظات دیگری تلاش نمایید.',
        error_dataalreadyexist: 'داده موجود است',
        error_dataalreadyexistpleaseselectantheer: 'داده موجود است.لطفا مورد دیگری انتخاب نمایید',
        error_connectionfailed: 'سرور در دسترس نیست',

        caption_appconfig: 'مدیریت برنامه ها',
        caption_baseinfo: 'اطلاعات پایه',
        caption_mainmenu: 'منوی اصلی',
        caption_other: 'سایر',
        caption_article: 'مقاله',
        caption_blog: 'بلاگ',
        caption_menu: 'منو',
        caption_permission: 'دسترسی',
        caption_group: 'گروه',
        caption_category: 'دسته بندی',
        caption_comment: 'نظر',
        caption_news: 'خبرها',
        caption_post: 'پست',
        caption_dashboard: 'پیشخوان',
        caption_slider: 'اسلایدر',
        caption_tag: 'تگ',
        caption_newstype: 'نوع خبر',
        caption_newstypes: 'خبر و انواع',
        caption_favorite: 'علاقه مندی ها',
        caption_advertisement: 'تبلیغات',
        caption_aboutus: 'درباره ما',
        caption_contactus: 'تماس با ما',
        caption_staticpages: 'صفحه های ایستا',
        caption_brand: 'برند',
        caption_product: 'محصول',
        caption_property: 'ویژگی',
        caption_shopping: 'فروشگاه',
        caption_user: 'کاربر',
        caption_setting: 'تنظیمات',
        caption_profile: 'پروفایل',
        caption_specific: 'اختصاصی',
        caption_location: 'محل',
        caption_expert: 'متخصص',
        caption_home: 'صفحه اصلی',
        caption_faq: 'پرسش و پاسخ',
        caption_newsletter: 'خبرنامه',
        caption_task: 'وظیفه',
        caption_ticket: 'بلیت',
        caption_city: 'شهر',
        caption_live: 'زنده',
        caption_playlist: 'آلبوم',
        caption_activationcode: 'کد فعالسازی',
    },
})
